module.exports = __webpack_public_path__ + "img/hr-V-R-4-load-standup-shadow.61190f8e.png";